import { useTranslation } from 'react-i18next'
import { styled } from 'styled-components'

import { UnderlineTabs } from '@root/shared/ui-kit'

import { useWalletTab } from './use-wallet-search-params'

export const WalletScreenTabs = () => {
  const { t } = useTranslation()
  const [tab, setTab] = useWalletTab()

  return (
    <UnderlineTabs value={tab} onChange={setTab}>
      <Tab value="assets">{t('wallet.your_assets')}</Tab>
      <Tab value="transactions">{t('transaction_other')}</Tab>
    </UnderlineTabs>
  )
}

const Tab = styled(UnderlineTabs.Tab)`
  text-transform: uppercase;
`
